export default "__VITE_ASSET__BGj879ez__"